import { render, staticRenderFns } from "./pricingDetail.vue?vue&type=template&id=a53e67ac&"
import script from "./pricingDetail.vue?vue&type=script&lang=js&"
export * from "./pricingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports